document.addEventListener('DOMContentLoaded', () => {
  const printBtn = document.querySelector('.print-button');

  if (printBtn) {
    printBtn.addEventListener('click', async () => {
      const imgs = document.querySelectorAll('img');

      // vypnúť lazy loading a vynútiť načítanie
      const promises = Array.from(imgs).map((img) => {
        img.loading = 'eager';
        if (img.dataset.src) img.src = img.dataset.src;
        if (img.dataset.srcset) img.srcset = img.dataset.srcset;
        if (img.dataset.lazySrc) img.src = img.dataset.lazySrc;
        if (img.dataset.lazySrcset) img.srcset = img.dataset.lazySrcset;

        // wait for image to load
        return new Promise((resolve) => {
          if (img.complete) resolve();
          else img.onload = img.onerror = () => resolve();
        });
      });

      // počkaj, kým sa všetky obrázky načítajú
      await Promise.all(promises);

      window.print();
    });
  }
});
